import { createHashHistory, HashHistory } from 'history'
import { useRef } from 'react'

// react-router's own <HashRouter> creates a hash history instance internally (via
// @remix-run/router's own createHashHistory({window, v5Compat: true})) but never exposes it, so
// nothing outside the router tree can call .block() on it. This uses the standalone `history`
// package instead (same one utils/history.ts uses for the outer shared history, fed into
// unstable_HistoryRouter the same way) - a different implementation of the same idea, not the
// literal internals @remix-run/router uses. It doesn't need (or have) a v5Compat option: unlike
// @remix-run/router's own history, this package's push/replace always notify listeners
// unconditionally (see applyTx in the `history` package's own source) - no gate to match.
export const useHashHistory = (): HashHistory => {
  const historyRef = useRef<HashHistory>()

  if (!historyRef.current) {
    historyRef.current = createHashHistory()
  }

  return historyRef.current
}
